import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { StripeProvider } from "react-stripe-elements"

import externalKeys from "./constants/externalKeys"

const AsyncStripeProvider = ({ children }) => {
    const [stripe, setStripe] = useState(null)
    useEffect(() => {
        const initStripe = () =>
            // eslint-disable-next-line no-undef
            setStripe(window.Stripe(externalKeys.stripeApiKey))

        // eslint-disable-next-line no-undef
        if (window.Stripe) {
            initStripe()
        } else {
            // eslint-disable-next-line no-undef
            document
                .getElementById("stripe-js")
                .addEventListener("load", () => initStripe())
        }
    }, [])

    return <StripeProvider stripe={stripe}>{children}</StripeProvider>
}

AsyncStripeProvider.propTypes = {
    children: PropTypes.node,
}

AsyncStripeProvider.defaultProps = {
    children: null,
}

export default React.memo(AsyncStripeProvider)
